'use client'

import * as React from 'react'
import { motion } from 'framer-motion'
import { cn } from '../../utils/cn'

interface SlideInProps {
  children: React.ReactNode
  delay?: number
  duration?: number
  direction?: 'left' | 'right'
  className?: string
}

export function SlideIn({
  children,
  delay = 0,
  duration = 0.6,
  direction = 'left',
  className
}: SlideInProps) {
  const xOffset = direction === 'left' ? -100 : 100

  return (
    <motion.div
      initial={{
        opacity: 0,
        x: xOffset
      }}
      whileInView={{
        opacity: 1,
        x: 0
      }}
      viewport={{ once: true, margin: '-100px' }}
      transition={{
        duration,
        delay,
        ease: [0.25, 0.1, 0.25, 1]
      }}
      className={cn(className)}
    >
      {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
      {children as any}
    </motion.div>
  )
}
